import React, { useState } from "react";
import { Box, CssBaseline, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GuestHeader from "../header/GuestHeader";
import GuestSidebar from "../sidebar/GuestSidebar";
import EmbeddedMoreSheet from "./EmbeddedMoreSheet";
import LayoutMain from "./LayoutMain";
import { isFlutterEmbeddedMobileViewport } from "@/shared/utils/taasEmbeddedContext";
import MobileFooterView from "../footer/MobileFooterView";

const GuestLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(!isMobile);
  const [moreSheetOpen, setMoreSheetOpen] = useState(false);

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const handleClose = () => setDrawerOpen(false);

  const showEmbeddedBottomNav = isFlutterEmbeddedMobileViewport(isMobile) || isMobile;
  // Mobile lobby uses the bottom nav for Lobby / Login / Sign Up — hide the sidebar drawer.
  const showSidebar = !showEmbeddedBottomNav;

  return (
    <Box sx={{ display: "flex", bgcolor: "var(--page-bg)", minHeight: "100dvh" }}>
      <CssBaseline />
      <GuestHeader toggleDrawer={toggleDrawer} showDrawerToggle={showSidebar} />
      {showSidebar && (
        <GuestSidebar open={drawerOpen} handleClose={handleClose} toggleDrawer={toggleDrawer} />
      )}

      <LayoutMain
        showBottomNav={showEmbeddedBottomNav}
        sx={{
          pt: "24px !important",
          width: showSidebar
            ? { xs: "100%", sm: `calc(100% - ${drawerOpen ? 240 : 72}px)` }
            : "100%",
          maxWidth: "100%",
          transition: "width 0.3s ease",
        }}
      />

      {showEmbeddedBottomNav && <MobileFooterView variant="user" />}

      <EmbeddedMoreSheet
        open={moreSheetOpen}
        onClose={() => setMoreSheetOpen(false)}
        actions={[
          {
            key: "wallet",
            label: "Wallet",
            onClick: () => navigate("/wallet"),
          },
          {
            key: "profile",
            label: "Manage Profile",
            onClick: () => navigate("/profile"),
          },
          {
            key: "scanQr",
            label: "Scan QR",
            onClick: () => navigate("/scan-qr"),
          },
          {
            key: "settings",
            label: "Settings",
            onClick: () => navigate("/settings"),
          },
        ]}
      />
    </Box>
  );
};

export default GuestLayout;
